export class RegulacionConstant {
    public static FIGURA_TOMADOR: String = 'T';
    public static MORAL: String = '01';
    public static RIESGO_TIPO_DNI: String = '01';
}



// WEBPACK FOOTER //
// ./src/app/contants/regulacion.constant.ts